import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import DashboardLayout from "@/layouts/DashboardLayout";
import { LayoutDashboard, ClipboardList, User } from "lucide-react";
import Overview from "@/pages/field/Overview";
import LeadsPage from "@/pages/shared/LeadsPage";
import ProfilePage from "@/pages/field/ProfilePage";

const NAV = [
  { to: "/field", key: "dashboard", icon: LayoutDashboard, end: true },
  { to: "/field/visits", key: "my_leads", icon: ClipboardList },
  { to: "/field/profile", key: "profile", icon: User },
];

export default function FieldDashboard() {
  return (
    <Routes>
      <Route element={<DashboardLayout title="FIELD EXECUTIVE" nav={NAV} testIdPrefix="field-nav" />}>
        <Route index element={<Overview />} />
        <Route path="visits" element={<LeadsPage role="field" />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="*" element={<Navigate to="/field" replace />} />
      </Route>
    </Routes>
  );
}
